module.exports = __webpack_public_path__ + "static/media/uncheck.3a81127d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/checkbox/uncheck.svg
// module id = 480
// module chunks = 0